import YYLoadingH from './loading-h'
export default YYLoadingH
